import { FC, useMemo } from "react";
import { OptionsWrapper, OptionsIconWrapper } from "./style";
import { HintTooltip, RectangularButtonHollow } from "@brg/ui";
import { useTranslation } from "react-i18next";
import { PinIcon } from "../icons/pin";
import { EditIcon } from "../icons/edit";
import { ProfileFoldersProps } from "shared/reducers/ProfileFoldersSlice";
import { HideIcon } from "../icons/hide";
import { getTooltipStyles } from "shared/constants/tooptipStyles";
import { useTheme } from "styled-components";
import { FolderT } from "../../tabs/const";

export const FolderOptions: FC<{ 
    activeFolder: FolderT,
    currentFolder: ProfileFoldersProps,
    isEmptyFolder?: boolean, 
    onEdit: () => void
    onPin: () => void,
    onHidden: () => void,
    onAdd: () => void 
}> = ({ 
    activeFolder, 
    currentFolder,
    isEmptyFolder, 
    onEdit,
    onPin,
    onHidden,
    onAdd 
}) => {
    const { t } = useTranslation();
    const theme = useTheme();

    const isPin = useMemo(() => (activeFolder?.isDefault), [activeFolder]);
    const isHide = useMemo(() => (!isPin && activeFolder?.isHidden) , [activeFolder, isPin])
    const isEditMode = useMemo(() => (currentFolder === ProfileFoldersProps.edit), [currentFolder]);

    if (isEmptyFolder) return null;
    
    return (
        <OptionsWrapper gx={24} gxMobile={16} offsetTop={24} offsetTopMobile={16}>
            <RectangularButtonHollow onClick={onAdd}>
                {t('folders.edit.add_projects')}
            </RectangularButtonHollow>
            <OptionsIconWrapper direction={'row'} gx={8}>
                <HintTooltip 
                    //@ts-ignore
                    customStyle={getTooltipStyles(theme)} 
                    text={t("folders.hints.pin")} 
                    z={6} 
                    noDisappearDelay 
                    onWhiteBg
                    positionY={'top'} 
                    /*{...tooltipProps}*/
                >
                    <PinIcon isActive={isPin} onClick={() => onPin()} />
                </HintTooltip>
                <HintTooltip 
                    //@ts-ignore
                    customStyle={getTooltipStyles(theme)} 
                    text={t("folders.hints.edit")} 
                    z={6} 
                    noDisappearDelay 
                    onWhiteBg
                    positionY={'top'} 
                    /*{...tooltipProps}*/
                >
                    <EditIcon isActive={isEditMode} onClick={() => onEdit()}/>
                </HintTooltip>
                <HintTooltip 
                    //@ts-ignore
                    customStyle={getTooltipStyles(theme)} 
                    text={t("folders.hints.hidden")} 
                    z={6} 
                    noDisappearDelay 
                    onWhiteBg
                    positionY={'top'} 
                    /*{...tooltipProps}*/
                >
                    <HideIcon disable={!!isPin} isActive={isHide} onClick={() => onHidden()}/>
                </HintTooltip>

            </OptionsIconWrapper>
        </OptionsWrapper>
    )
}import { FC, useMemo } from "react";
import { OptionsWrapper, OptionsIconWrapper } from "./style";
import { HintTooltip, RectangularButtonHollow } from "@brg/ui";
import { useTranslation } from "react-i18next";
import { PinIcon } from "../icons/pin";
import { EditIcon } from "../icons/edit";
import { ProfileFoldersProps } from "shared/reducers/ProfileFoldersSlice";
import { HideIcon } from "../icons/hide";
import { getTooltipStyles } from "shared/constants/tooptipStyles";
import { useTheme } from "styled-components";
import { FolderT } from "../../tabs/const";

export const FolderOptions: FC<{ 
    activeFolder: FolderT,
    currentFolder: ProfileFoldersProps,
    isEmptyFolder?: boolean, 
    onEdit: () => void
    onPin: () => void,
    onHidden: () => void,
    onAdd: () => void 
}> = ({ 
    activeFolder, 
    currentFolder,
    isEmptyFolder, 
    onEdit,
    onPin,
    onHidden,
    onAdd 
}) => {
    const { t } = useTranslation();
    const theme = useTheme();

    const isPin = useMemo(() => (activeFolder?.isDefault), [activeFolder]);
    const isHide = useMemo(() => (!isPin && activeFolder?.isHidden) , [activeFolder, isPin])
    const isEditMode = useMemo(() => (currentFolder === ProfileFoldersProps.edit), [currentFolder]);

    if (isEmptyFolder) return null;
    
    return (
        <OptionsWrapper gx={24} gxMobile={16} offsetTop={24} offsetTopMobile={16}>
            <RectangularButtonHollow onClick={onAdd}>
                {t('folders.edit.add_projects')}
            </RectangularButtonHollow>
            <OptionsIconWrapper direction={'row'} gx={8}>
                <HintTooltip 
                    //@ts-ignore
                    customStyle={getTooltipStyles(theme)} 
                    text={t("folders.hints.pin")} 
                    z={6} 
                    noDisappearDelay 
                    onWhiteBg
                    positionY={'top'} 
                    /*{...tooltipProps}*/
                >
                    <PinIcon isActive={isPin} onClick={() => onPin()} />
                </HintTooltip>
                <HintTooltip 
                    //@ts-ignore
                    customStyle={getTooltipStyles(theme)} 
                    text={t("folders.hints.edit")} 
                    z={6} 
                    noDisappearDelay 
                    onWhiteBg
                    positionY={'top'} 
                    /*{...tooltipProps}*/
                >
                    <EditIcon isActive={isEditMode} onClick={() => onEdit()}/>
                </HintTooltip>
                <HintTooltip 
                    //@ts-ignore
                    customStyle={getTooltipStyles(theme)} 
                    text={t("folders.hints.hidden")} 
                    z={6} 
                    noDisappearDelay 
                    onWhiteBg
                    positionY={'top'} 
                    /*{...tooltipProps}*/
                >
                    <HideIcon disable={!!isPin} isActive={isHide} onClick={() => onHidden()}/>
                </HintTooltip>

            </OptionsIconWrapper>
        </OptionsWrapper>
    )
}